import React from 'react'
import { ListWrapper, ListWrapperProps } from '@cbgms/components/list-wrapper/ListWrapper'
import { supportGetSettings, supportRemoveSettings, supportSetSettings } from '@cbgms/components/grid/state/actions'
import { mapRejectionToMessage } from 'core/page/DeleteErrors'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { MenuItem } from './MenuItem'
import SupportDeleteModalContainer from './SupportDeleteModalContainer'

type SupportListWrapperProps<T> = ListWrapperProps<T>

function SupportListWrapper<T>(
  props: SupportListWrapperProps<T> & {
    wholesalerFormModal?: boolean | { templateList: any[] }
    onDownload?: (selectedTemplate: string) => void
    onRowClassName?: (row: any) => string | undefined
  }
) {
  const userID = useSelector((state: IRootReducerState) => state.auth.user.email)
  const getUserID = React.useCallback(() => userID || '', [userID])

  const additionalProps = {
    hideUUIDColumns: false,
    getSettings: supportGetSettings,
    storeSettings: supportSetSettings,
    removeSettings: supportRemoveSettings,
    getUserID,
    mapRejectionToMessage,
    DefaultMenuItemComponent: MenuItem,
    DeleteModalContainer: SupportDeleteModalContainer
  }

  return <ListWrapper {...props} {...additionalProps} onDownload={props.onDownload} />
}

export default SupportListWrapper
